import { Injectable, inject } from '@angular/core';
import { LicenseGandalfService } from '@gandalf/services';

@Injectable({
	providedIn: 'root',
})
export class LicenseService {
	licenseGandalfService = inject(LicenseGandalfService);

	/*istanbul ignore next: gandalf*/
	getAgreementDetails() {
		return this.licenseGandalfService.getAgreementDetails();
	}
}
